import { render, staticRenderFns } from "./SMSForm.vue?vue&type=template&id=632b3a4b&scoped=true&"
import script from "./SMSForm.vue?vue&type=script&lang=js&"
export * from "./SMSForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632b3a4b",
  null
  
)

export default component.exports